import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_VOICES_MIX = defineFcm('supporter_voices_mix')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				itemsPerRow: { type: 'number' },
				maxRows: { type: 'number' },
				commentsPerVideo: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Petition details',
		description: `Configures the mixed supporter voices feed on the petition page. Setting any value enables the feed (replacing the legacy comments + videos sections).
		- itemsPerRow: cards per row (combined with maxRows to cap the total item pool)
		- maxRows: maximum rows to display (total items = itemsPerRow * maxRows)
		- commentsPerVideo: ratio of comment cards to video cards (1 = 1:1 alternating)`,
		import: false,
		template: {
			itemsPerRow: 3,
			maxRows: 2,
			commentsPerVideo: 1,
		},
	});
